import { Box, Chip } from "@mui/material";
import { ReferenceRow } from "../../types/model/reference";

interface ReferenceRowCellsProps {
  row: ReferenceRow;
  fields: string[];
  t: (key: string) => string;
}

export const ReferenceRowCells: React.FC<ReferenceRowCellsProps> = ({
  row,
  fields,
  t,
}) => (
  <>
    {fields.map((field, colIndex) => (
      <Box
        key={field}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {(row as any)[field]}
        {colIndex === 0 && (
          <Chip
            label={`${t("admin.reference.table.row-id")}: ${row.id}`}
            size="small"
            className="id-chip"
            sx={{ ml: 2, opacity: 0, transition: "opacity 0.3s" }}
          />
        )}
      </Box>
    ))}
  </>
);